export default "__VITE_ASSET__ea6xqGtj__"